import { LockKeyhole } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Badge } from "@/components/ui/v2/badge";
import { Button } from "@/components/ui/v2/button";
import { inputVariants } from "@/components/ui/v2/input-variants";
import { cn } from "@/lib/utils/cn";

type StoredSecretProps = {
  fieldLabel: string;
  disabled?: boolean;
  onChange: () => void;
};

export function StoredSecret({ fieldLabel, disabled, onChange }: StoredSecretProps) {
  const { t } = useTranslation();
  const changeLabel = t("integrations.modules.configure.fields.changeSecret");

  return (
    <div className={cn(inputVariants(), "flex items-center gap-3 pr-1", disabled && "opacity-50")}>
      <span aria-hidden className="flex-1 select-none text-base leading-none tracking-[0.2em] text-foreground">
        ••••••••••••
      </span>
      <Badge variant="success" size="medium">
        <LockKeyhole aria-hidden />
        {t("integrations.modules.configure.fields.storedSecret")}
      </Badge>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="h-7"
        disabled={disabled}
        aria-label={`${changeLabel} ${fieldLabel}`}
        onClick={onChange}
      >
        {changeLabel}
      </Button>
    </div>
  );
}
